// extracted by mini-css-extract-plugin
module.exports = {"container":"story-top-component_container__-EcOn"};